module.exports = __webpack_public_path__ + "static/media/Everest_Menu.5ab62769.pdf";